module.exports = __webpack_public_path__ + "static/media/YB_User_Background_Icon@2x.cd253cdd.png";